module.exports = __webpack_public_path__ + "img/ResidentControl4.6affcb55.png";